<!--
  * name: Product Detail
  * description: [Main] Product Detail 컴포넌트 페이지
-->
<template>
  <div>
    <bread-crumb location="products"></bread-crumb>
    <!-- 병헌 : 경로 -->
    <product-main-info :product="product" v-if="isLoaded"/>
    <section>
      <div class="tabtit mt-10 mb-10">
        <span
          @click="(isDetail = true), (isUse = false)"
          :class="{ active: isDetail }"
          >상세정보</span
        >
        ㆍ
        <span
          @click="(isUse = true), (isDetail = false)"
          class="tit"
          :class="{ active: isUse }"
          >배송/반품/환불</span
        >
      </div>

      <section class="container detail" v-if="isDetail && product.contents" v-html="$sanitize(product.contents)">
      </section>
      <!-- 배송,환불,반품 상세정보영역 -->
      <information v-if="isUse" />
      <!-- 배송,환불,반품 상세정보영역 -->

      <!-- 관련상품 영역 -->
      <related-product :products="relatedProductsList"/>
      <!-- 관련상품 영역 -->
    </section>
  </div>
</template>

<script>

import '@/assets/plugins/swiper.min.css';
import BreadCrumb from '@/components/breadcrumb/BreadCrumb.vue';
import productApi from '@/apis/product';
import Information from './partial/Information.vue';
import ProductMainInfo from './partial/ProductMainInfo.vue';
import RelatedProduct from './partial/RelatedProduct.vue';

export default {
  name: 'ProductDetail',
  components: {
    BreadCrumb,
    Information,
    ProductMainInfo,
    RelatedProduct,
  },
  props: ['productId'],
  watch: {
    productId() {
      this.init();
      this.isDetail = true;
      this.isUse = false;
      this.getRelatedProductsList();
    },
  },
  data() {
    return {
      relatedProductsList: [],
      isDetail: true /* 상세정보 보기 */,
      isUse: false /* 배송/반품/환불 보기 */,
      product: {},
      isLoaded: false,
    };
  },
  async created() {
    await this.init();
    this.getRelatedProductsList();
  },
  methods: {
    async init() {
      const result = await productApi.getProductDetail(this.productId);
      if (result.error) {
        this.$router.push('/products');
      } else {
        console.log('result.code=', result.code);
        if (result.code === '4004') {
          alert('해당 상품이 존재하지 않습니다.');
          this.$router.push('/products');
          return ;
        }

        this.product = result.data;
        this.isLoaded = true;
      }
    },
    async getRelatedProductsList() {
      const productList = await productApi.getProducts();
      this.relatedProductsList = productList.filter((n) => n.productsId !== parseInt(this.productId, 10));
    },
  },
};
</script>

<style lang="scss">
@import '@/assets/css/product.scss';
</style>
